/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable quote-props */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable-next-line no-unused-vars */
/** * This file is auto-generated by generate-palette.js
 * Do not edit this file directly. Instead, update the Figma tokens and re-run the script.
 */
// Helper function to convert alpha (0-1) + hex to HEXA format
const toHEXA = (hex, alpha) => {
  if (alpha === 1) return hex;
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, '0')
    .toUpperCase();
  return `${hex}${alphaHex}`;
};

const palette = {
  dark: {
    divider: '#FFFFFF1F',
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFFB2',
      disabled: '#FFFFFF61',
      '_states': {
        hover: '#FFFFFF14',
        selected: '#FFFFFF29',
        focus: '#FFFFFF1F',
        focusVisible: '#FFFFFF4D',
      },
    },
    primary: {
      main: '#9DD2A5',
      dark: '#56B568',
      light: '#E6F4E9',
      contrastText: '#213657DE',
      '_states': {
        background: '#E6F4E914',
        hover: '#E6F4E914',
        selected: '#E6F4E929',
        focus: '#E6F4E91F',
        focusVisible: '#E6F4E94D',
        outlinedBorder: '#E6F4E980',
      },
    },
    secondary: {
      main: '#CE93D8',
      dark: '#AB47BC',
      light: '#F3E5F5',
      contrastText: '#000000DE',
      '_states': {
        background: '#CE93D814',
        hover: '#CE93D814',
        selected: '#CE93D829',
        focus: '#CE93D81F',
        focusVisible: '#CE93D84D',
        outlinedBorder: '#CE93D880',
      },
    },
    action: {
      active: '#FFFFFF',
      hover: '#FFFFFF14',
      selected: '#FFFFFF29',
      focus: '#FFFFFF1F',
      disabled: '#FFFFFF4D',
      disabledBackground: '#FFFFFF1F',
      contrastColor: '#213657',
    },
    error: {
      main: '#F44336',
      dark: '#D32F2F',
      light: '#E57373',
      contrastText: '#FFFFFF',
      '_states': {
        background: '#F4433614',
        hover: '#F443364D',
        selected: '#F4433629',
        focusVisible: '#F44336B2',
        outlinedBorder: '#F4433680',
      },
    },
    warning: {
      main: '#FFA726',
      dark: '#F57C00',
      light: '#FFB74D',
      contrastText: '#000000DE',
      '_states': {
        background: '#FFA72614',
        hover: '#FFA72614',
        selected: '#FFA72629',
        focusVisible: '#FFA7264D',
        outlinedBorder: '#FFA72680',
      },
    },
    info: {
      main: '#29B6F6',
      dark: '#0288D1',
      light: '#4FC3F7',
      contrastText: '#000000DE',
      '_states': {
        background: '#29B6F614',
        hover: '#29B6F614',
        selected: '#29B6F629',
        focusVisible: '#29B6F64D',
        outlinedBorder: '#29B6F680',
      },
    },
    success: {
      main: '#56B568',
      dark: '#22883A',
      light: '#75C282',
      contrastText: '#000000DE',
      '_states': {
        background: '#66BB6A14',
        hover: '#66BB6A14',
        selected: '#66BB6A29',
        focusVisible: '#66BB6A4D',
        outlinedBorder: '#66BB6A80',
      },
    },
    common: {
      black: {
        '_states': {
          main: '#000000',
          hover: '#00000014',
          selected: '#00000029',
          focus: '#0000001F',
          focusVisible: '#0000004D',
          outlinedBorder: '#00000080',
        },
      },
      white: {
        '_states': {
          main: '#FFFFFF',
          hover: '#FFFFFF14',
          selected: '#FFFFFF29',
          focus: '#FFFFFF1F',
          focusVisible: '#FFFFFF4D',
          outlinedBorder: '#FFFFFF80',
          actionDisable: '#FFFFFF80',
        },
      },
    },
    '_components': {
      paper: {
        'elevation-0': '#121212',
        'elevation-1': '#1E1E1E',
        'elevation-2': '#232323',
        'elevation-3': '#252525',
        'elevation-4': '#272727',
        'elevation-5': '#2A2A2A',
        'elevation-6': '#2C2C2C',
        'elevation-7': '#2C2C2C',
        'elevation-8': '#2E2E2E',
        'elevation-9': '#2E2E2E',
        'elevation-10': '#313131',
        'elevation-11': '#313131',
        'elevation-12': '#333333',
        'elevation-13': '#333333',
        'elevation-14': '#333333',
        'elevation-15': '#333333',
        'elevation-16': '#363636',
        'elevation-17': '#363636',
        'elevation-18': '#363636',
        'elevation-19': '#363636',
        'elevation-20': '#383838',
        'elevation-21': '#383838',
        'elevation-22': '#383838',
        'elevation-23': '#383838',
        'elevation-24': '#383838',
      },
      table: {
        border: '#515151',
        tableAltRow: '#F5F5F5',
        tableHeader: '#455163',
      },
      avatar: {
        fill: '#6E747C',
      },
      input: {
        standard: {
          enabledBorder: '#FFFFFF6B',
          hoverBorder: '#FFFFFF',
        },
        filled: {
          enabledFill: '#FFFFFF17',
          hoverFill: '#FFFFFF1F',
        },
        outlined: {
          enabledBorder: '#FFFFFF3B',
          hoverBorder: '#FFFFFF',
        },
      },
      switch: {
        knobFillEnabled: '#D9DFE8',
        slideFill: '#FFFFFF61',
        knowFillDisabled: '#6E747C',
      },
      rating: {
        enabledBorder: '#FFFFFF3B',
        activeFill: '#FFB400',
      },
      chip: {
        defaultCloseFill: '#FFFFFF',
        defaultHoverFill: '#FFFFFF1F',
        defaultEnabledBorder: '#5B6067',
        defaultFocusFill: '#FFFFFF33',
      },
      tooltip: {
        fill: '#616161E5',
      },
      backdrop: {
        fill: '#00000080',
      },
      breadcrumbs: {
        collapseFill: '#6E747C',
      },
      alert: {
        error: {
          color: '#F4C7C7',
          background: '#160B0B',
        },
        warning: {
          color: '#FFE2B7',
          background: '#191207',
        },
        info: {
          color: '#B8E7FB',
          background: '#071318',
        },
        success: {
          color: '#CCE8CD',
          background: '#0C130D',
        },
      },
      stepper: {
        connector: '#6E747C',
      },
    },
    background: {
      default: '#121212',
    },
    '_native': {
      'scrollbar-bg': '#5B6067',
    },
  },
  light: {
    divider: '#2136571F',
    text: {
      primary: '#213657',
      secondary: '#5B6067',
      disabled: '#979DA5',
      '_states': {
        hover: '#2136570A',
        selected: '#21365714',
        focus: '#2136571F',
        focusVisible: '#2136574D',
      },
    },
    primary: {
      main: '#22883A',
      dark: '#01581D',
      light: '#56B568',
      contrastText: '#FFFFFF',
      '_states': {
        background: '#22883A14',
        hover: '#22883A4D',
        selected: '#22883A14',
        focus: '#22883A1F',
        focusVisible: '#22883AB2',
        outlinedBorder: '#22883A80',
      },
    },
    secondary: {
      main: '#2397F3',
      dark: '#1A77D2',
      light: '#65B6F6',
      contrastText: '#FFFFFF',
      '_states': {
        background: '#1A77D214',
        hover: '#1A77D24D',
        selected: '#1A77D214',
        focus: '#1A77D21F',
        focusVisible: '#1A77D2B2',
        outlinedBorder: '#1A77D280',
      },
    },
    action: {
      active: '#2136578A',
      hover: '#2136571F',
      selected: '#21365714',
      focus: '#2136571F',
      disabled: '#21365742',
      disabledBackground: '#2136571F',
      contrastColor: '#FFFFFF',
    },
    error: {
      main: '#D32F2F',
      dark: '#C62728',
      light: '#EF5350',
      contrastText: '#FFFFFF',
      '_states': {
        background: '#D32F2F0A',
        hover: '#D32F2F4D',
        selected: '#D32F2F14',
        focusVisible: '#D32F2FB2',
        outlinedBorder: '#D32F2F80',
      },
    },
    warning: {
      main: '#EF6C00',
      dark: '#E65100',
      light: '#FF9800',
      contrastText: '#FFFFFF',
      '_states': {
        background: '#EF6C0014',
        hover: '#EF6C004D',
        selected: '#EF6C0014',
        focusVisible: '#EF6C00B2',
        outlinedBorder: '#EF6C0080',
      },
    },
    info: {
      main: '#0288D1',
      dark: '#01579B',
      light: '#03A9F4',
      contrastText: '#FFFFFF',
      '_states': {
        background: '#0288D114',
        hover: '#0288D14D',
        selected: '#0288D114',
        focusVisible: '#0288D1B2',
        outlinedBorder: '#0288D180',
      },
    },
    success: {
      main: '#22883A',
      dark: '#01581D',
      light: '#75C282',
      contrastText: '#FFFFFF',
      '_states': {
        background: '#2E7D3214',
        hover: '#2E7D324D',
        selected: '#2E7D3214',
        focusVisible: '#2E7D32B2',
        outlinedBorder: '#2E7D3280',
      },
    },
    common: {
      black: {
        '_states': {
          main: '#000000',
          hover: '#0000000A',
          selected: '#00000014',
          focus: '#0000001F',
          focusVisible: '#0000004D',
          outlinedBorder: '#00000080',
        },
      },
      white: {
        '_states': {
          main: '#FFFFFF',
          hover: '#FFFFFF0A',
          selected: '#FFFFFF14',
          focus: '#FFFFFF1F',
          focusVisible: '#FFFFFF4D',
          outlinedBorder: '#FFFFFF80',
          actionDisable: '#FFFFFFBF',
        },
      },
    },
    '_components': {
      paper: {
        'elevation-0': '#FFFFFF',
        'elevation-1': '#FFFFFF',
        'elevation-2': '#FFFFFF',
        'elevation-3': '#FFFFFF',
        'elevation-4': '#FFFFFF',
        'elevation-5': '#FFFFFF',
        'elevation-6': '#FFFFFF',
        'elevation-7': '#FFFFFF',
        'elevation-8': '#FFFFFF',
        'elevation-9': '#FFFFFF',
        'elevation-10': '#FFFFFF',
        'elevation-11': '#FFFFFF',
        'elevation-12': '#FFFFFF',
        'elevation-13': '#FFFFFF',
        'elevation-14': '#FFFFFF',
        'elevation-15': '#FFFFFF',
        'elevation-16': '#FFFFFF',
        'elevation-17': '#FFFFFF',
        'elevation-18': '#FFFFFF',
        'elevation-19': '#FFFFFF',
        'elevation-20': '#FFFFFF',
        'elevation-21': '#FFFFFF',
        'elevation-22': '#FFFFFF',
        'elevation-23': '#FFFFFF',
        'elevation-24': '#FFFFFF',
      },
      table: {
        border: '#E2E4E7',
        tableAltRow: '#F8F8F9',
        tableHeader: '#455163',
      },
      avatar: {
        fill: '#B6BCC4',
      },
      input: {
        standard: {
          enabledBorder: '#2136576B',
          hoverBorder: '#213657',
        },
        filled: {
          enabledFill: '#2136570F',
          hoverFill: '#21365717',
        },
        outlined: {
          enabledBorder: '#2136573B',
          hoverBorder: '#213657',
        },
      },
      switch: {
        knobFillEnabled: '#F4FAFF',
        slideFill: '#000000',
        knowFillDisabled: '#EFF5FE',
      },
      rating: {
        enabledBorder: '#2136573B',
        activeFill: '#FFB400',
      },
      snackbar: {
        fill: '#213657',
      },
      chip: {
        defaultCloseFill: '#213657',
        defaultHoverFill: '#2136571F',
        defaultEnabledBorder: '#B6BCC4',
        defaultFocusFill: '#21365733',
      },
      tooltip: {
        fill: '#616161E5',
      },
      backdrop: {
        fill: '#00000080',
      },
      breadcrumbs: {
        collapseFill: '#EFF5FE',
      },
      alert: {
        error: {
          color: '#5F2120',
          background: '#FDEDED',
        },
        warning: {
          color: '#663C00',
          background: '#FFF4E5',
        },
        info: {
          color: '#014361',
          background: '#E5F6FD',
        },
        success: {
          color: '#1E4620',
          background: '#EDF7ED',
        },
      },
      stepper: {
        connector: '#B6BCC4',
      },
    },
    background: {
      default: '#FAFAFA',
    },
    '_native': {
      'scrollbar-bg': '#E8EEF6',
    },
  },
};

export default palette;
